import { render } from "./PrincipalPage.vue?vue&type=template&id=319e825a&scoped=true"
import script from "./PrincipalPage.vue?vue&type=script&lang=js"
export * from "./PrincipalPage.vue?vue&type=script&lang=js"

import "./PrincipalPage.vue?vue&type=style&index=0&id=319e825a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319e825a"]])

export default __exports__